<template>
    <div>
        <v-card :class="{'bordered':checked && showoutline}" class="pa-3" :outlined="showoutline" elevation="0" @mouseenter="showExampleImage = true" @mouseleave="showExampleImage = false">
            <v-card class="" @focus="false" :ripple="false" elevation="0"  min-height="140" max-width="110">
                <div @click="checked = !checked" class="clickable">
                    <div class="icon-container">
                        <v-img class="rounded-lg" :src="`/files/images/${icon}`" width="86" :aspect-ratio="1"></v-img>
                    </div>
                    <div class="appname-container text-center text-subtitle-2">
                        {{ name }} 
                    </div>
                </div>
                <input v-show="showcheckbox" v-model="checked" class="app-checkbox" type="checkbox">
            </v-card>
        </v-card>
        <div v-if="object != null && object.exampleImage != null && object.exampleImage != ''" class="ad-example-image-wrapper" v-bind:style="{'opacity': showExampleImage ? 1 : 0, 'visibility': showExampleImage ? 'visible' : 'hidden'}">
            <span>{{ $t("preview") }}</span>
            <div class="ad-example-image" v-bind:style="{'background-image': 'url(/files/images/' + object.exampleImage + ')'}">
                <div class="ad-example-image-phone"></div>
            </div>
        </div>
    </div>
    
</template>

<script>
export default {
    name: "AppIconCheck",

    props: {
        type:String,
        id: Number,
        icon: String,
        checked: Boolean,
        name: String,
        showcheckbox: Boolean,
        showoutline: Boolean,
        object: Object,
        fetchobj:Object,
    },


    data() {
        return {
            showoutline: false,
            showcheckbox: false,
            checked: false,
            selection: null,
            showExampleImage: false,
            fetched: null,
        }
    },

    watch: {
        fetchobj:{
            handler(val) {
                var _this = this;
                if(_this.fetchobj == null || Object.keys(_this.fetchobj).length === 0){
                    return;
                }
                if(_this.fetchobj.id == _this.object.id){
                    _this.checked = true;
                }
            },
            deep: true,
            immediate:true,
        }, 
        checked: function(val){
            if(this.showcheckbox){
                if(val){
                    this.$emit('select',this.object);
                }else if(this.object == null){
                    return;
                }else{
                    this.$emit('unselect',this.object);
                }
            }
            if(this.showoutline){
                if(val){
                    this.$emit('select',this.object);
                }else if(!val && this.object == null){
                    return;
                }else{
                    this.$emit('unselect',this.object);
                }
            }
        },
        selection: function(val){
            if(val.id != this.object.id){
                this.checked = false;
            }else if(val.id != this.object.id){
                this.checked = true;
            }
        }
    },

    created(){
    },

    mounted() {
    },


    methods: {
        uncheck(obj){
            this.selection = obj;
        },
        check(obj){
            this.selection = obj;
        },
        handle(){
            var _this = this;
            setTimeout(() => {
                if(_this.fetchobj == null) return;
                if(_this.fetchobj.id == _this.object.id){
                _this.checked = true;
            }}, 500);
        }
    },
}
</script>

<style scoped>
.icon-container {
    padding: 4px 12px;
}
.clickable{
    cursor: pointer;
}

input[type=checkbox].app-checkbox {
    transform: scale(1.5);
    height: 14px;
    position: absolute;
    top: 0;
    right: 9px;
}


input[type=checkbox].app-checkbox:before {
    height: 30px;
    width: 30px;
    display: block;
    position: absolute;
    content: "";
} 

.app-checkbox input[type=checkbox]:after {
    height: 30px;
    width: 30px;
    display: block;
    position: absolute;
    content: "";
}

.theme--light.v-sheet--outlined{
    border-radius: 10px;
    border: solid transparent;
}

.bordered.theme--light.v-sheet--outlined{
    border-radius: 10px;
    border: solid #2F3452;
}

.bordered .v-image{
    filter: invert(19%) sepia(12%) saturate(1918%) hue-rotate(193deg) brightness(40%) contrast(92%);
}



</style>